interface IActionTypeWrapper
    extends IActionType
{
    model: any;
}

class SiteActionWrapper
    extends SiteAction {

    private readonly _action: IActionTypeWrapper;
    private readonly _card: ISiteCard;
    private readonly _next: SiteActionSubmit | SiteActionRequest;

    constructor(card: ISiteCard, action: IActionType, next: SiteAction | null) {
        super(null);

        if (next == null || !(next instanceof SiteActionSubmit || next instanceof SiteActionRequest))
            throw "Cannot wrap without a next action.";
        
        this._next = next;
        this._action = action as IActionTypeWrapper;
        this._card = card;
    }
    
    async _execute() {
        // -- Wrap current model with next action
        let nextAction = this._next.getAction();
        let nextActionSetModel: boolean;
        let nextActionModel: any;

        if (this._next instanceof SiteActionSubmit)
        {
            let nextActionCasted = <IActionTypeSubmit>nextAction;
            nextActionSetModel = nextActionCasted.setModel;
            nextActionModel = nextAction.actionLink.model;

            if (nextActionSetModel) {
                nextAction.actionLink.model = this._card.Model.get(SiteModel.split(nextActionCasted.path));
                (<IActionTypeSubmit>nextAction).setModel = false;
            }
        } else {
            nextActionSetModel = false;
            nextActionModel = nextAction.actionLink.model;
        }


        // Now wrap nextAction.ActionLink.Model with action.Model
        this._action.model.model = nextAction.actionLink.model;
        nextAction.actionLink.model = this._action.model;

        // And run the next action
        let result = await this._next.execute();

        // Set back to original values:
        nextAction.actionLink.model = nextActionModel;
        if (this._next instanceof SiteActionSubmit)
            (<IActionTypeSubmit>nextAction).setModel = nextActionSetModel;

        return result;
    }
}